module.exports = __webpack_public_path__ + "static/media/liora.393d3786.png";